import { apiRequest, postApiRequest } from './_tools';

export function fetchPerformance({ period, breakdown, filter }) {
  return postApiRequest('/api/dashboard/performance/graph/metrics', {
    period,
    breakdown,
    filter,
  }).catch(({ error }) => Promise.reject(error));
}

export function fetchTablePerformance({ period, filter, page, itemsPerPage, sort }) {
  return postApiRequest('/api/dashboard/performance/table', {
    period,
    sort,
    filter,
    page,
    itemsPerPage,
  }).catch(({ error }) => Promise.reject(error));
}

export function fetchApps() {
  return apiRequest('/api/apps-dashboard')
    .catch(({ error }) => Promise.reject(error));
}

export function fetchPlacements() {
  return apiRequest('/api/apps/placements-dashboard')
    .catch(({ error }) => Promise.reject(error));
}

export function fetchAdUnits() {
  return apiRequest('/api/apps/ad-units-dashboard')
    .catch(({ error }) => Promise.reject(error));
}

export function fetchFiltersData() {
  return apiRequest('/api/dashboard/filters-data')
    .catch(({ error }) => Promise.reject(error));
}

export function exportTablePerformanceCSV({ period, filter, sort }) {
  return postApiRequest('/api/dashboard/performance/table/csv', {
    period,
    sort,
    filter,
  }).catch(({ error }) => Promise.reject(error));
}

export function fetchInsights({ period, filter }) {
  return postApiRequest('/api/dashboard/performance/graph/insights', {
    period,
    filter,
  }).catch(({ error }) => Promise.reject(error));
}



/** WEBPACK FOOTER **
 ** ./js/core/api/dashboard.js
 **/